import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CheckBoxToggleModule } from '../shared-ui-components/checkbox-toggle';
import { CookiesNotificationBannerComponent } from './cookies-notification-banner';
import { PrivacyCenterComponent } from './privacy-center';

@NgModule({
  imports: [CommonModule, CheckBoxToggleModule, RouterModule],
  declarations: [CookiesNotificationBannerComponent, PrivacyCenterComponent],
  exports: [CookiesNotificationBannerComponent],
})
export class PrivacySettingsModule {}
